import { Link } from 'react-router-dom'
import {Mail, MapPin, Phone} from 'lucide-react'

function Footer() {
  return (
    <footer className="border-t border-[#E5E5E5] bg-[#0A0A0A] text-[#FAFAF7]">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-baseline gap-2 mb-2">
              <span className="font-display text-3xl font-semibold tracking-tight">Triangle Project Consultants</span>
            </div>
            <div className="font-mono text-[11px] uppercase tracking-widest text-[#F59E0B] mb-4">
              AI-Enhanced Solutions
            </div>
            <p className="text-sm text-white/60 max-w-md leading-relaxed mb-4">
              Expert project consulting services enhanced by AI technology to help organizations achieve
              strategic goals and drive business growth.
            </p>
            <p className="font-mono text-[11px] uppercase tracking-widest text-white/40">
              HUB Certified · NCSBE Certified
            </p>
          </div>

          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-white/40 mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2 text-white/80">
                <Mail size={14} className="mt-1 text-[#F59E0B] flex-shrink-0" />
                <a href="mailto:Triangleprojectconsultants@gmail.com" className="hover:text-[#F59E0B] transition-colors break-all">
                  Triangleprojectconsultants@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2 text-white/80">
                <Phone size={14} className="mt-1 text-[#F59E0B] flex-shrink-0" />
                <a href="tel:+19199303059" className="hover:text-[#F59E0B] transition-colors">
                  (919) 930-3059
                </a>
              </li>
              <li className="flex items-start gap-2 text-white/80">
                <MapPin size={14} className="mt-1 text-[#F59E0B] flex-shrink-0" />
                <span>Raleigh, NC<br />United States</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-white/40 mb-4">Resources</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="https://www.triangleprojectconsultants.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-[#F59E0B] transition-colors inline-flex items-center gap-1"
                >
                  Main Website ↗
                </a>
              </li>
              <li>
                <Link
                  to="/"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="text-white/80 hover:text-[#F59E0B] transition-colors"
                >
                  Assessment Home
                </Link>
              </li>
              <li>
                <Link to="/quiz" className="text-white/80 hover:text-[#F59E0B] transition-colors">Take the Quiz</Link>
              </li>
              <li>
                <Link to="/privacy" className="text-white/80 hover:text-[#F59E0B] transition-colors">Privacy Policy</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 justify-between items-start md:items-center">
          <p className="font-mono text-xs text-white/40">
            © {new Date().getFullYear()} Triangle Project Consultants. All rights reserved.
          </p>
          <p className="font-mono text-xs text-white/40">
            Made in Raleigh, NC · USA
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
